import store from '../store/store';
import { action } from 'satcheljs/lib/legacy';
export default action('setForwardingEmailAddress')(function setForwardingEmailAddress(emailAddress) {
    store.forwardingEmailAddress = emailAddress;
});
//# sourceMappingURL=setForwardingEmailAddress.js.map